import React,{ PureComponent}  from 'react';
import $ from 'jquery';
import {Link} from 'react-router-dom';
import NickViewers from 'common/components/nick-viewers/NickViewers';
import './Anchor.scss';
import immutable from 'immutable';

export default class Anchor extends PureComponent{
    componentDidMount() {
        this.$lazyload = $(this.refs.lazyload);
        this.$lazyload.lazyload({
            threshold: '180'
        });
    }
    componentDidUpdate(){
        this.$lazyload.lazyload({
            threshold: '180'
        });
    }

	shouldComponentUpdate(nextProps) {
		return !(nextProps.info === this.props.info || immutable.is(nextProps.info, this.props.info));
	}

    render() {
        const props =  this.props;
        const info = props.info;
        
        var privateHost = info.get("privateHost");
        var profileRoom = info.get("roomId") || info.get("profileRoom");
        const path = isNaN(privateHost) ? info.get("privateHost") : (!profileRoom ? 'yy/' + privateHost : profileRoom);
        
        return (
	        <li className="m-subscribe-anchor clickstat" data-uid={info.get("uid")}  data-stat={"Click/sub/position" + props.index + "|点击/订阅/卡片"+ props.index}>
		        <Link to={{pathname: '/' + path, search: props.search}}>
			        <span className={"a-status " + (info.get("isLive") === true? 'living' : '')}>{info.get("isLive")=== true? '在播' : ''}</span>
			        <div className="a-pic" ref="lazyload"  data-original={info.get("avatar180")}></div>
			        <NickViewers sNick={info.get("nick")} iNumber={info.get("total_count")} noViewer={!info.get("isLive")}/>
		        </Link>
	        </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/subscriber-list/anchor/Anchor.jsx